import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CollectionFacade } from './collection.facade'
import { CollectionViewComponent } from './components/collection-view/collection-view.component'
import { CollectionTabViewComponent } from './components/collection-tab-view/collection-tab-view.component'
import { EventListItemComponentModule } from '../libs/events/components/event-list-item/event-list-item.component.module'
import { NodeListModule } from '../libs/nodes/components/node-list/node-list.module'
import { CollectionsService } from '../libs/collections/services/collections.service'
import { SharedModule } from '../shared/shared.module'
import { HeaderLayoutModule } from '../libs/header-layout/header-layout.module'
import { CollectionSidebarModule } from '../libs/collections/components/collection-sidebar/collection-sidebar.module'
import { AdsModule } from '../shared/ads/ads.module'
import { NodeListWidgetModule } from '../libs/nodes/components/node-list-widget/node-list-widget.module'
import { CollectionsResolver } from './collections.resolver'
import { CollectionHeaderComponentModule } from '../libs/collections/components/collection-header/collection-header.component.module'
import { EntityHubDataService } from '../entity-hub/entity-hub-data.service'
import { CollectionAnalyticsService } from './collection-analytics.service'
import { OldTabComponent } from '../libs/_deprecated/tabs/old-tab.component'
import { OldTabsComponent } from '../libs/_deprecated/tabs/old-tabs.component'
import { OldTabsModule } from '../libs/_deprecated/tabs/old-tabs.module'

/**
 * @deprecated
 * New bff-powered entity collections/hub initiative will replace this module.
 * See @EntityHubModule
 */
@NgModule({
  imports: [
    CollectionHeaderComponentModule,
    CommonModule,
    EventListItemComponentModule,
    NodeListModule,
    OldTabsModule,
    SharedModule,
    HeaderLayoutModule,
    CollectionSidebarModule,
    AdsModule,
    NodeListWidgetModule
  ],
  providers: [
    CollectionsService,
    CollectionFacade,
    CollectionsResolver,
    EntityHubDataService,
    CollectionAnalyticsService
  ],
  declarations: [CollectionViewComponent, CollectionTabViewComponent],
  exports: [CollectionViewComponent, CollectionTabViewComponent, OldTabsComponent, OldTabComponent]
})
export class CollectionsBaseModule {}
